import { convertMediaUrl } from "@montana/helpers/media-src.helper";
import { IM22ColourAndSurfacesBlock, IColorMaterialDescriptionBlock, IM20ImageBlock } from "@montana/models/generated/cms.interface";
import { MaterialSwatch } from "@montana/shared/material-swatch/material-swatch.component";
import { RichText } from "@montana/shared/rich-text";
import React, { useEffect, useState } from "react";
import {
    IM20ImageBlockExtended,
    M20ImagePatternBlock
} from "../m20-image-pattern-block/m20-image-pattern-block.component";

export const M22ColoursAndSurfacesBlock: React.VFC<IM22ColourAndSurfacesBlock> = props => {
    const [selectedNav, setSelectedNav] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (props.colourBlocks?.length) {
            const colourBlock = props.colourBlocks[0] as IColorMaterialDescriptionBlock;
            setSelectedNav(colourBlock.header);
        }
    }, [])

    function GetHrefLink(header: string | undefined) {
        if (!header) {
            return "";
        }

        const asciiHeader = header.split(" ").join("-");
        return (
            `color-material-view-${asciiHeader.toLocaleLowerCase()}`
        )
    }

    return (
        <>
            <section className="colours-and-surfaces-block" id="colours-and-surfaces">
                {!!props.header && (
                    <RichText
                        text={props.header}
                    />
                )}
                <div className="colours-and-surfaces-block__content">
                    {props.showLeftNavigation &&
                        <div className="colours-and-surfaces-block__navigation">
                            {(props.colourBlocks as IColorMaterialDescriptionBlock[])?.map((colourBlock, index) => {
                                return (
                                    <div
                                        key={`anchor-${index}`}
                                        onClick={() => {
                                            setSelectedNav(colourBlock.header);
                                        }}
                                    >
                                        <a
                                            className={`colours-and-surfaces-block__navigation-link ${selectedNav === colourBlock.header ? "colours-and-surfaces-block__navigation-link--first" : ""}`}
                                            href={location.pathname + location.search + '#' + GetHrefLink(colourBlock.header)}
                                        >
                                            {colourBlock.header}
                                        </a>
                                    </div>
                                )
                            })}
                            {!!props.blocks &&
                                (props.blocks as IM20ImageBlock[]).map((block, index) => {
                                    return(
                                        <div
                                            key={`anchor-${index}`}
                                            onClick={() => {
                                                setSelectedNav(block.name);
                                            }}
                                        >
                                            <a
                                                className={`colours-and-surfaces-block__navigation-link ${selectedNav === block.name ? "colours-and-surfaces-block__navigation-link--first" : ""}`}
                                                href={location.pathname + location.search + '#' + GetHrefLink(block.name)}
                                            >
                                                {block.name}
                                            </a>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }

                    <div>
                        {(props.colourBlocks as IColorMaterialDescriptionBlock[])?.map((colourBlock, index) => (
                            <article className="colours-and-surfaces-block" key={`colourBlock${index}`} id={GetHrefLink(colourBlock.header)}>
                                {!!colourBlock.header && (
                                    <h1 className="color-material-description-block__heading">
                                        {colourBlock.header}
                                    </h1>
                                )}

                                {!!colourBlock.headerDescription && (
                                    <p className="color-material-description-block__description">
                                        {colourBlock.headerDescription}
                                    </p>
                                )}
                                {!!colourBlock.colorMaterials && (
                                    <ul className="colours-and-surfaces-block__materials">
                                        {colourBlock.colorMaterials.map((colorMaterial, index) => {
                                            return (
                                                <li
                                                    className="colours-and-surfaces-block__material"
                                                    key={`colorMaterial-${index}`}
                                                >
                                                    <MaterialSwatch
                                                        className="colours-and-surfaces-block__material-image"
                                                        imageSrc={convertMediaUrl(
                                                            colorMaterial.colorSwatchImage?.url
                                                        )}
                                                        color={colorMaterial.hexCode}
                                                    />
                                                    {colorMaterial.colorDescription && (
                                                        <div className="colours-and-surfaces-block__material-name">
                                                            {colorMaterial.colorDescription}
                                                        </div>
                                                    )}

                                                    {colorMaterial.surface && (
                                                        <div className="colours-and-surfaces-block__material-description">
                                                            {colorMaterial.surface}
                                                        </div>
                                                    )}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                )}
                            </article>
                        ))}
                        {(props.blocks as IM20ImageBlockExtended[])?.map((block, index) => (
                                    <div id={GetHrefLink(block.name)} key={`M20ImagePatternBlock-${index}`} >
                                        <M20ImagePatternBlock
                                            {...block}
                                            withoutContainer
                                        />
                                    </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};
